import styled, { createGlobalStyle } from 'styled-components';

import { Box } from '@spa/shared/components/Modal/styles';
import { mediaMin } from '@spa/shared/theme';

export const ModalGlobalStyle = createGlobalStyle`
  .wishlist {
    ${Box} {
      display: flex;
      flex-direction: column;
    }
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  & > p {
    font-family: IntervalNextReg, sans-serif;
    font-weight: 100;
    line-height: normal;
    font-size: ${props => props.theme.rem(16)};
    line-height: 1.31;
    color: ${props => props.theme.wishlistModal.textColor};

    ${props => props.theme.smallBreakpoint`
      margin-top: ${props => props.theme.space(4)};
    `};
  }

  & > svg {
    position: absolute;
    bottom: -${props => props.theme.space(7)};
    right: ${props => props.theme.space(17)};
    width: 135px;
    height: auto;

    ${props => props.theme.smallBreakpoint`
      position: initial;
    `};
  }

  ${mediaMin.smallBreakpoint`
    align-items: center;
  `};
`;

export const ActionsWrapper = styled.div`
  display: flex;
  width: 50%;
  margin-top: ${props => props.theme.space(15)};

  ${props => props.theme.smallBreakpoint`
    width: 100%;
  `};

  & > button {
    height: 44px;
    margin: 0;

    &:first-child {
      margin-right: ${props => props.theme.space(4)};
    }
  }
`;
